@if (visible()) {
<div class="email-gate-overlay">
  <div class="email-gate-card">
    @if (!awaitingVerification()) {
    <h2>Add your email</h2>
    <p>
      Your account doesn't have an email address yet. Purchases and receipts
      are sent by email, so we need one before you can continue.
    </p>
    <input
      type="email"
      name="email"
      placeholder="you@example.com"
      autocomplete="email"
      [(ngModel)]="email"
      [disabled]="saving()"
      (keyup.enter)="save()"
    />
    @if (error()) {
    <p class="email-gate-error">{{ error() }}</p>
    }
    <button type="button" [disabled]="!canSave" (click)="save()">
      {{ saving() ? LoadingMessage.Saving : 'Save' }}
    </button>
    } @else {
    <h2>Check your inbox</h2>
    <p>
      We've sent a verification link to <strong>{{ email }}</strong
      >. Open it to verify your email address.
    </p>
    <button type="button" class="email-gate-link" (click)="useDifferentEmail()">
      Use a different email
    </button>
    }
  </div>
</div>
}
